import Vue from "vue";
import VueRouter from "vue-router";
import Risk from "../views/Risk.vue";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    props: true,
  },
  {
    path: "/policy-tracker/:domainId?/:regionId?",
    name: "policy",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "policy" */ "../views/Policy.vue"),
    props: true,
  },
  {
    path: "/:dataset(girls|boys)/:domainId?/:indicatorId?/:iso?",
    name: "risk",
    component: Risk,
    props: true,
  },
  {
    path: "/:domainId?/:indicatorId?/:iso?",
    redirect: (to) => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { name: "risk", params: { ...to.params, dataset: "girls" } };
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
